<template>
  <div class="col-lg-12 col-md-6 col-sm-12 boton-panel">
    <div>
      <div class="col-12 row">
        <boton-accesorio v-for="item in lstKilometraje" :key="item.id" :datos="item" v-model="kilometrajeSeleccionado" />
      </div>
    </div>
  </div>
</template>

<script>
import botonAccesorio from '../../componentes/boton-accesorio.vue';

export default {
  props: ["kilimetrajes", "porcentajeIva"],

  components: { botonAccesorio },

  data: () => ({
    color1: "red",
    suma: 0,
    capturaDatos: [],
    lstKilometraje: [], //lista de kilometraje
    contador: 0,
    kilometrajeSeleccionado: [],
    kilometrajesERP: [],
    lista: [],
    porcentajeIvaAplicar: 0,
  }),

  methods: {
    sumarMantenimientos: function () {
      const arrayGeneral = this.kilometrajeSeleccionado
      this.suma = 0
      this.contador = 0
      arrayGeneral.forEach((res) => {
        this.suma = this.suma + res.ndt2;
        this.contador++
      })

      if (this.contador > 2) {
        this.$emit('valorSuma', this.suma);
      } else {
        this.$emit('valorSuma', 0);
      }
      this.$emit('kilometrajeSeleccionado', this.kilometrajeSeleccionado);
    },

    valdiarStilo: function (item) {
      var result = kilometrajeSeleccionado.find((items) => items.dt2 === item.dt2);
      return result;
    },
  },

  watch: {

    kilimetrajes: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.lstKilometraje = val;
        }
      }
    },

    porcentajeIva: {
      immediate: true,
      handler(val, oldVal) {
        if (val) {
          this.porcentajeIvaAplicar = val;
        }
      }
    },

    kilometrajeSeleccionado: {
      immediate: true,
      handler(val, oldVal) {
        this.sumarMantenimientos()
      }
    },

    contador() {
      this.$emit('contador', this.contador)
    }

  },
};

</script>

 
